import { render } from "./ListEmpresas.vue?vue&type=template&id=36e1f22a"
import script from "./ListEmpresas.vue?vue&type=script&lang=js"
export * from "./ListEmpresas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__